export enum EModalActeType {
	Creation = 0,
	Edition,
	Seance
}